import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from './cn'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'w-full px-4 py-3 rounded-xl bg-surface text-ink placeholder:text-ink-subtle',
        'border border-line focus:border-brand focus:outline-none',
        'focus:ring-2 focus:ring-brand/30 transition-all duration-150',
        'disabled:opacity-50 disabled:cursor-not-allowed resize-y',
        invalid && 'border-error focus:border-error focus:ring-error/30',
        className,
      )}
      {...rest}
    />
  )
})
